// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:03:51

export default {
  "id": "wonders-of-egypt-mahjong",
  "slug": "wonders-of-egypt-mahjong",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e07f57a52e994a4c802e595bc77a788c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e07f57a52e994a4c802e595bc77a788c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Wonders of Egypt Mahjong",
      "description": "Wonders of Egypt Mahjong transports you to the mystical world of Ancient Egypt in this brand-new Solitaire Mahjong game. Play through beautifully designed hand-drawn tiles featuring Egyptian motifs and captivating backgrounds inspired by the wonders of Egypt. With 40 unique new layouts and three smaller tutorial layouts, it’s perfect for both beginners and Mahjong experts. Dive into hours of challenging gameplay and uncover the secrets of the Pharaohs!",
      "instructions": "Find and match identical tiles, making sure they’re free on at least one side to remove them from the board. Clear all tiles to complete each layout and unveil the mysteries of Egypt! Use Shuffle, Torch, or Hint if you’re stuck, and earn stars as you progress through endless puzzles. Relax and enjoy the beauty of Ancient Egypt in this captivating Solitaire Mahjong journey!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "board",
        "egypt",
        "tiles"
      ]
    },
    "zh-CN": {
      "title": "埃及奇迹麻将",
      "description": "《埃及奇迹麻将》将您带入这个全新的埃及神秘世界单人麻将游戏。通过精美的手绘瓷砖，展示埃及图案和令人着迷的背景，灵感来源于埃及奇迹。包含40种独特的新布局和三个较小的教程布局，非常适合初学者和麻将高手。沉浸于数小时的挑战性玩法，揭开法老的秘密！",
      "instructions": "找到并匹配相同的瓷砖，确保它们至少有一边是空闲的，以便从板上移除。清除所有瓷砖以完成每个布局，揭示埃及的秘密！如果你卡住了，可以使用洗牌、火炬或提示，随着你在无尽的谜题中前进，赚取星星。在这个迷人的单人纸牌麻将旅程中，放松并欣赏古埃及的美景！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "棋盘",
        "埃及",
        "瓷砖"
      ]
    },
    "zh-TW": {
      "title": "埃及奇蹟麻將",
      "description": "埃及奇蹟麻將將您帶入神秘古老的埃及世界，這是一款全新的單人遊戲麻將。通過精美設計的親手繪製瓦片，展示埃及圖案和令人著迷的背景，啟發於埃及的奇蹟。擁有40種獨特的全新佈局和三個較小的教學佈局，適合初學者和麻將高手。沉浸於小時的挑戰遊戲，揭開法老的秘密！",
      "instructions": "尋找並匹配相同的磁磚，確保它們至少在一側是自由的，以便從棋盤上移除。清空所有磁磚以完成每個佈局，揭開埃及的神秘！如果你遇到難題，可以使用洗牌、火炬或提示功能，隨著你通過無盡的謎題進展，獲得星星。放鬆並享受這個引人入勝的埃及單人 mahjong 旅程中的古埃及美景！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "棋盤",
        "埃及",
        "磚塊"
      ]
    },
    "zh-HK": {
      "title": "埃及奇蹟麻將",
      "description": "埃及奇蹟麻將將您帶入神秘古埃及的世界，這是一款全新的單人麻將遊戲。遊玩精心設計的描繪風格瓷砖，特別是融合埃及風情的圖案和令人著迷的背景，靈感來自埃及的奇蹟。擁有40種獨特的新佈局和三種較小的教學佈局，適合初學者和麻將專家。深入挑戰數小時的遊戲，揭開法老王的秘密！",
      "instructions": "尋找並配對相同的地圖，確保至少一邊是自由的以從棋盤上移除它們。清空所有地圖以完成每個佈局並揭開埃及的謎團！如果遇到難關，可使用洗牌、火炬或提示功能，隨著進度通過無盡的謎題，獲得星級評分。放鬆身心，欣賞古埃及的絕美風情，在迷人的單人牌遊戲馬具珠之旅中盡情享受！",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "棋盤",
        "埃及",
        "地圖磚"
      ]
    },
    "ja": {
      "title": "エジプトの驚異 マージャン",
      "description": "エジプトの驚異 Mahjongは、この全く新しいソロ Mahjongゲームであなたを神秘的な古代エジプトの世界へと連れて行きます。エジプトのモチーフを特徴とする美しくデザインされた手描きのタイルと、エジプトの驚異にインスパイアされた魅力的な背景を楽しむことができます。40種類のユニークな新しいレイアウトと、3つの小さなチュートリアルレイアウトを含み、初心者からマージョンエキスパートまで幅広く楽しめます。挑戦的なゲームプレイを楽しみ、ファラオの秘密を解き明かしましょう！",
      "instructions": "同じタイルを見つけ、少なくとも一方が開いている状態でボードから取り除く。全てのタイルをクリアして、それぞれのレイアウトを完了し、エジプトの謎を解き明かそう！ストック、ランプ、ヒントを使用して困った場合があり、無限のパズルを進むにつれて星を獲得。古代エジプトの美しさを楽しみながら、魅力的なソリテール麻雀の旅を楽しもう！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "ボード",
        "エジプト",
        "タイル"
      ]
    },
    "ko": {
      "title": "에gypt의 기적 마작",
      "description": "에gypt의 기적 Mahjong에서는 이제 막 시작된 Solitaire Mahjong 게임을 통해 신비로운 고대 이집트의 세계로带你进入神秘的世界。에gypt의 기적을 영감으로 양식화된 아름다운 수채화 타일을 통해 게임을 즐겨보세요. 40개의 독특한 새로운 레이아웃과 세 개의 작은 튜토리얼 레이아웃으로, 초보자와 Mahjong 전문가 모두에게 적합합니다. 도전적인 게임 플레이를 몇 시간 동안 즐기고, 파라오들의 비밀을 밝혀보세요!",
      "instructions": "동일한 타일을 찾아 일치시키며, 하나 이상의 측면이 자유롭게 되어 있도록 하여 게임판에서 제거하세요. 모든 타일을 클리어하여 각 레이아웃을 완료하고 이집트의 비밀을 밝혀보세요. 막힐 때는 셔플, torch, 또는 힌트를 사용하고, 끝없는 퍼즐을 해결하면서 별을 획득하세요. 이 매력적인 솔리테어 마 jong 여정에서 고대 이집트의 아름다움을 쉬어보세요!",
      "genres": [
        "캐주얼",
        "패자드림"
      ],
      "tags": [
        "보드",
        "이집트",
        "타일"
      ]
    },
    "fr": {
      "title": "Merveilles de l'Égypte Mahjong",
      "description": "Wonders of Egypt Mahjong vous emmène dans le monde mystique de l'Égypte antique dans ce nouveau jeu de Mahjong Solitaire. Jouez avec des tuiles magnifiquement conçues et dessinées à la main, présentant des motifs égyptiens et des arrière-plans captivants inspirés des merveilles de l'Égypte. Avec 40 configurations uniques et trois configurations didactiques plus petites, il est parfait pour les débutants et les experts en Mahjong. Plongez dans des heures de jeu captivant et découvrez les secrets des Pharaons !",
      "instructions": "Trouvez et associez des tuiles identiques, en vous assurant qu’elles sont libérées d’au moins un côté pour les enlever du plateau. Videz toutes les tuiles pour terminer chaque disposition et découvrir les mystères de l’Égypte ! Utilisez le Mélange, le Torche ou l’Indice si vous êtes bloqué, et gagnez des étoiles en progressant à travers les puzzles infinis. Détendez-vous et profitez de la beauté de l’Égypte antique dans ce captivant voyage de Solitaire Mahjong !",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "grille",
        "Égypte",
        "tuiles"
      ]
    }
  }
};
